<!-- Diese Liste dient zur Ausgabe aller Anmeldungen für eine Veranstaltung -->
<template>
  <div class="list">
    <notifications></notifications>
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
            ></head-menu-filter>

            <div class="row mb-2">
              <div
                class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10"
              >
                <div class="row">
                  <div class="col-xl-12">
                    <single-select-person
                      id="anmeldung-von"
                      :person="filters.person"
                      :label="$t('global.person')"
                      :allowOpen="false"
                      :rollen="filterRollen"
                      :activeonly="false"
                      editable
                      @confirmed="setFilterPerson"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <single-select-firma
                      :firma="filters.firma"
                      :label="$t('global.company')"
                      :allowOpen="false"
                      :rollen="filterRollen"
                      :activeonly="false"
                      editable
                      @confirmed="setFilterFirma"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model.trim="filters['kanton']"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t('global.canton') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <date-picker
                        date-format="dd.mm.yy"
                        placeholder=" "
                        :initial="filters['veranstaltung.startdatumVon']"
                        :show-icon="true"
                        field="veranstaltung.startdatumVon"
                        @updatefull="setFilterDate"
                      />
                      <label>{{ $t('global.registrationdatefrom') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <date-picker
                        date-format="dd.mm.yy"
                        placeholder=" "
                        :initial="filters['veranstaltung.startdatumBis']"
                        :show-icon="true"
                        field="veranstaltung.startdatumBis"
                        @updatefull="setFilterDate"
                      />
                      <label>{{ $t('global.registrationdateuntil') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model.trim="filters.geschlecht"
                        :options="geschlechter"
                        label="bezeichnung"
                        :placeholder="$t('global.gender')"
                      ></v-select>
                      <label>{{ $t('global.gender') }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <single-select-veranstaltung
                      id="anmeldung-klasse-veranstaltung"
                      :veranstaltung="filters.veranstaltung"
                      :label="$t('global.event')"
                      :allowOpen="false"
                      editable
                      @confirmed="setFilterVeranstaltung"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model.trim="filters.veranstaltungsstatus"
                        :options="veranstaltungsstati"
                        :reduce="(vs) => vs.id"
                        label="bezeichnung"
                        :placeholder="$t('global.eventstatus')"
                        multiple
                      >
                        <span slot="no-options">
                          {{ $t('global.nostatusfound') }}
                        </span>
                      </v-select>
                      <label>{{ $t('global.eventstatus') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model.trim="filters.veranstaltungstyp"
                        :options="veranstaltungstypen"
                        :reduce="(vt) => vt.id"
                        label="bezeichnung"
                        :placeholder="$t('global.typeofevent')"
                        multiple
                      >
                        <span slot="no-options">
                          {{ $t('global.notypesfound') }}
                        </span>
                      </v-select>
                      <label>{{ $t('global.eventtype') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model.trim="filters.statusAnmeldung"
                        :options="anmeldestati"
                        :reduce="(vt) => vt.id"
                        label="bezeichnung"
                        :placeholder="$t('global.status')"
                        multiple
                      >
                        <span slot="no-options">
                          {{ $t('global.nostatusfound') }}
                        </span>
                      </v-select>
                      <label>{{ $t('global.registrationstatus') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model.trim="filters.anmeldungstyp"
                        :options="anmeldetypen"
                        :reduce="(s) => s.id"
                        label="bezeichnung"
                        :placeholder="$t('global.type')"
                        multiple
                      >
                        <span slot="no-options">
                          {{ $t('global.notypefound') }}
                        </span>
                      </v-select>
                      <label>{{ $t('global.typeofregistration') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model.trim="filters.bildungsgangTyp"
                        :options="bildungsgangtypen"
                        :reduce="(v) => v.id"
                        label="bezeichnung"
                        :placeholder="$t('global.educationcoursetype')"
                        multiple
                      ></v-select>
                      <label>{{ $t('global.educationcoursetype') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.remarks"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t('global.remarks') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12 my-2">
                    <div
                      class="form-group-inline"
                      style="margin-left: 7px"
                    >
                      <label
                        class="float-left"
                        style="
                          font-size: 11px !important;
                          font-weight: 700 !important;
                        "
                      >
                        {{ $t('global.no_communication_adress') }}
                      </label>
                      <input
                        class="form-check-input float-right mx-3"
                        style="margin-top: 0.2rem"
                        v-model="filters['keine_kommunikationsadresse']"
                        type="checkbox"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12 my-2">
                    <div
                      class="form-group-inline"
                      style="margin-left: 7px"
                    >
                      <label
                        class="float-left"
                        style="
                          font-size: 11px !important;
                          font-weight: 700 !important;
                        "
                      >
                        {{ $t('global.notsubsidized') }}
                      </label>
                      <input
                        class="form-check-input float-right mx-3"
                        style="margin-top: 0.2rem"
                        v-model="filters['nicht_subventioniert']"
                        type="checkbox"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div
                      class="form-group"
                      id="number-of-records"
                    >
                      <input
                        v-model="filters.count"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t('global.numberofrecords') }}</label>
                    </div>
                  </div>
                </div>
                <filter-search-reset-button />
                <!--Oder Statement switch-->
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <button
                        class="btn btn-secondary"
                        @click="toggleOrParameter"
                      >
                        {{
                          filters.orStatement
                            ? $t('global.orfilteractive')
                            : $t('global.orfilterinactive')
                        }}
                      </button>
                    </div>
                  </div>
                </div>
                <!--Ende Oder Statement switch-->
              </div>
            </div>
          </div>
        </div>
        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.listofregistrations')"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
              :gesamtanzahl="gesamtanzahl"
            ></head-menu>
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row mt-2 d-flex justify-content-between">
                  <div
                    class="ml-4"
                    style="display: flex"
                  >
                    <massenmutation-button
                      class="mr-2"
                      :selectedIds="this.selectedIds"
                      :propEntities="propEntities"
                      @mutated="refresh"
                    />
                    <button
                      class="btn btn-primary mr-2"
                      v-if="berechtigungen.m_anmeldungen.update"
                      @click="showAnmeldungUebertragen"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-sign-out-alt"
                        class="mr-2"
                      />
                      <span>{{ $t('global.transferregistration') }}</span>
                    </button>

                    <b-dropdown variant="primary mr-2">
                      <template slot="button-content">
                        <font-awesome-icon
                          icon="fa-duotone fa-print"
                          class="mr-2"
                        />
                        <em>{{ $t('global.output') }}</em>
                      </template>
                      <b-dropdown-item @click="ausgebenTeilnehmerliste">
                        {{ $t('global.participantlist') }}
                      </b-dropdown-item>
                      <b-dropdown-item @click="ausgebenTischkarten">
                        {{ $t('global.placecards') }}
                      </b-dropdown-item>
                    </b-dropdown>

                    <b-dropdown
                      variant="primary mr-2"
                      v-if="berechtigungen.m_korrespondenz.update"
                    >
                      <template slot="button-content">
                        <font-awesome-icon
                          icon="fa-duotone fa-envelope-open-text"
                          class="mr-2"
                        />
                        {{ $t('global.createmassmail') }}
                      </template>
                      <b-dropdown-item @click="massenmailErstellen(true)">
                        {{ $t('global.selected') }}
                      </b-dropdown-item>
                      <b-dropdown-item @click="massenmailErstellen(false)">
                        {{ $t('global.alldisplayed') }}
                      </b-dropdown-item>
                    </b-dropdown>

                    <b-dropdown
                      variant="primary mr-2"
                      v-if="berechtigungen.m_korrespondenz.update"
                    >
                      <template slot="button-content">
                        <font-awesome-icon
                          icon="fa-duotone fa-memo"
                          class="mr-2"
                        />
                        {{ $t('global.createserialletter') }}
                      </template>
                      <b-dropdown-item
                        @click="massenkorrespondenzErstellen(true)"
                      >
                        {{ $t('global.selected') }}
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="massenkorrespondenzErstellen(false)"
                      >
                        {{ $t('global.alldisplayed') }}
                      </b-dropdown-item>
                    </b-dropdown>

                    <button
                      class="btn btn-primary mr-2"
                      @click="exportToExcel(listData, 'anmeldungen')"
                    >
                      <span class="mr-2">
                        <font-awesome-icon
                          icon="fa-regular fa-file-spreadsheet"
                        />
                      </span>
                      {{ $t('global.export') }}
                    </button>
                  </div>
                  <div class="mr-4">
                    <button
                      class="btn btn-danger"
                      @click="oeffneLoeschenModal"
                      v-if="berechtigungen.m_anmeldungen.delete"
                    >
                      <font-awesome-icon
                        class="mr-1"
                        icon="fa-duotone fa-trash"
                      />
                      <span>{{ $t('global.delete') }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Start Reiter Liste / Selected -->
            <!-- <div class="reiterrow row d-flex">
              <div
                class="listenreiter"
                :class="{ active: listTab === 1 }"
                @click="listTab = 1"
                v-tooltip.hover
                :title="$t('global.foundentries')"
              >
                <font-awesome-icon
                  v-if="listTab === 1"
                  icon="fa-sharp fa-solid fa-list"
                />
                <font-awesome-icon
                  v-if="listTab === 2"
                  icon="fa-sharp fa-light fa-list"
                />
              </div>
              <div
                class="listenreiter"
                :class="{
                  active: listTab === 2,
                  disabled: selectedIds.length === 0,
                }"
                @click="selectedIds.length > 0 ? (listTab = 2) : (listTab = 1)"
                v-tooltip.hover
                :title="
                  $t('global.selectedentries') + ': ' + selectedIds.length
                "
              >
                <font-awesome-icon
                  v-if="listTab === 2"
                  icon="fa-solid fa-check-square"
                />
                <font-awesome-icon
                  v-if="listTab === 1"
                  icon="fa-light fa-check-square"
                />
                &nbsp;
                <span>{{
                  selectedIds.length > 0 ? selectedIds.length : ""
                }}</span>
              </div>
            </div> -->
            <!-- End Reiter Liste / Selected -->
            <div class="row block belegliste belegliste-small">
              <div class="w-100-p">
                <div>
                  <b-table
                    ref="selectableTable"
                    small
                    tbody-tr-class="item"
                    :items="listData"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-compare="sortDates"
                    sort-icon-left
                    selectable
                    select-mode="range"
                    @row-dblclicked="details"
                    thead-tr-class="pointer"
                  >
                    <template
                      slot="top-row"
                      slot-scope="{ fields }"
                    >
                      <td
                        class="no-pointer"
                        v-for="field in fields"
                        :key="field.key"
                      >
                        <b-input
                          v-if="
                            field.key != 'selected' && field.searchable != false
                          "
                          size="sm"
                          v-model="filters[field.key]"
                          :placeholder="field.label"
                        />
                      </td>
                    </template>

                    <template v-slot:head(selected)="header">
                      <b-form-checkbox
                        ref="headerCheckbox"
                        v-model="header.selected"
                        @input="selectAllRows(header)"
                      ></b-form-checkbox>
                    </template>

                    <template v-slot:cell(selected)="row">
                      <b-form-checkbox
                        v-model="row.item.selected"
                        @input="onRowSelected(row)"
                      ></b-form-checkbox>
                    </template>

                    <template v-slot:cell(anmeldungsdatum)="row">
                      <div>
                        {{
                          row.item.anmeldungsdatum || row.item.warteliste || '-'
                        }}
                      </div>
                    </template>

                    <template
                      v-slot:cell(veranstaltung.veranstaltungstyp.bezeichnung)="row"
                    >
                      <div :style="veranstaltungstypHintergrundfarbe(row.item)">
                        {{
                          row.item.veranstaltung.veranstaltungstyp
                            ? row.item.veranstaltung.veranstaltungstyp
                                .bezeichnung
                            : '-'
                        }}
                      </div>
                    </template>
                  </b-table>
                  <infinite-loading
                    :identifier="infiniteId"
                    @infinite="infiniteHandler"
                  >
                    <div slot="spinner">{{ $t('global.loadmoredata') }}</div>
                    <div slot="no-more">{{ $t('global.nofurtherdata') }}</div>
                    <div slot="no-results">
                      {{ $t('global.nofurtherdatafound') }}
                    </div>
                  </infinite-loading>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loeschen-modal
      id="anmeldungen-loeschen-modal"
      @confirmed="anmeldungenLoeschen"
      :selectedIds="selectedIds"
    />

    <pdf-layer
      id="pdf-layer"
      ref="pdfLayer"
      :src="{
        url: pdfPath,
        withCredentials: true,
      }"
    ></pdf-layer>

    <anmeldung-uebertragen-modal
      id="anmeldung-uebertragen-modal"
      :allowCopy="true"
      @copied="anmeldungGeaendert"
      @changed="anmeldungGeaendert"
    ></anmeldung-uebertragen-modal>

    <messagebox-count
      :headerText="$t('global.registrationsdeleted')"
      id="count-delete-alert-msgbox"
      :ok="true"
      :cancel="false"
      :okText="$t('global.ok')"
      :cancelText="$t('global.cancel')"
    />

    <loading-overlay v-show="loading"></loading-overlay>
    <alert-modal
      id="modal-alert"
      :title="alertModal.title"
      :text="alertModal.text"
      :color="alertModal.color"
      :value="alertModal.value"
      @confirmed="korrespondenzSwitch(alertModal.value)"
    />
  </div>
</template>

<script>
  import Api from '@/api/Api'
  import HeadMenu from '@/components/HeadMenu'
  import HeadMenuFilter from '@/components/HeadMenuFilter'
  import Navbar from '@/components/Navbar'

  import store from '@/store'
  import page from '@/mixins/Page'
  import dashboard from '@/mixins/Dashboard'
  import filter from '@/mixins/Filter'
  import server from '@/server'
  import excelExport from '@/mixins/ExcelExport'

  import LoeschenModal from '@/components/Modals/LoeschenModal'
  import AnmeldungUebertragenModal from '@/components/Modals/AnmeldungUebertragenModal'
  import SingleSelectPerson from '@/components/global/SingleSelectPerson.vue'
  import SingleSelectFirma from '@/components/global/SingleSelectFirma.vue'
  import SingleSelectVeranstaltung from '@/components/global/SingleSelectVeranstaltung.vue'
  import AlertModal from '@/components/Modals/AnmeldungAlertModal'
  import MassenmutationButton from '@/components/Buttons/MassenmutationButton'
  import FilterSearchResetButton from '@/components/Buttons/FilterSearchResetButton'
  import DatePicker from '@/components/Datepicker.vue'

  import { LADE_AUSWAHLWERTE_ANMELDUNG } from '@/store/anmeldung/actions.type'

  import { LADE_AUSWAHLWERTE_VERANSTALTUNG } from '@/store/veranstaltung/actions.type'
  import { LADE_AUSWAHLWERTE_GESCHAEFTSPARTNER } from '@/store/geschaeftspartner/actions.type'

  export default {
    name: 'AnmeldungslisteSKJV',
    components: {
      Navbar,
      DatePicker,
      HeadMenu,
      HeadMenuFilter,
      LoeschenModal,
      AnmeldungUebertragenModal,
      SingleSelectPerson,
      SingleSelectFirma,
      SingleSelectVeranstaltung,
      AlertModal,
      MassenmutationButton,
      FilterSearchResetButton,
    },
    metaInfo() {
      return {
        titleTemplate: () => {
          return 'BX: ' + this.$t('global.dashboard_registrations')
        },
      }
    },
    mixins: [page, dashboard, excelExport, filter],
    props: {},
    store,
    data() {
      return {
        filterRollen: this.$CONST('ROLLEN').STUDENTEN,
        pdfPath: '',
        sortBy: 'person.personName',
        sortDesc: false,
        alertModal: {
          color: null,
          text: '',
          title: '',
          value: '',
        },
        propEntities: [
          {
            tbl_name: 'bxc_anmeldungen',
            selectedIds: [],
          },
        ],
        firstVisit: true,
        isDozent: false,
        defaultEventType: this.$CONST('CONFIG').EVENTTYPE,
      }
    },
    computed: {
      fields() {
        return [
          { key: 'selected', label: '' },
          {
            key: 'anmeldungsdatum',
            sortable: true,
            searchable: false,
            thClass: 'text-center',
            tdClass: 'text-center',
            label: this.$t('global.registered'),
          },
          {
            key: 'person.personName',
            sortable: true,
            label: this.$t('global.person'),
          },
          {
            key: 'person.viafirma.name',
            sortable: true,
            searchable: true,
            label: this.$t('global.company'),
          },
          {
            key: 'anmeldestatus.bezeichnung',
            sortable: true,
            searchable: false,
            label: this.$t('global.status'),
          },
          {
            key: 'anmeldetyp.bezeichnung',
            sortable: true,
            searchable: false,
            label: this.$t('global.registrationtype'),
          },
          {
            key: 'veranstaltung.kuerzel',
            sortable: true,
            label: this.$t('global.shortdesignation'),
          },
          {
            key: 'veranstaltung.bezeichnung',
            sortable: true,
            label: this.$t('global.event'),
          },
          {
            key: 'veranstaltung.startdatum',
            sortable: true,
            searchable: false,
            thClass: 'text-center',
            tdClass: 'text-center',
            label: this.$t('global.startdate'),
          },
          {
            key: 'veranstaltung.veranstaltungstyp.bezeichnung',
            sortable: true,
            searchable: false,
            label: this.$t('global.eventtype'),
          },
        ]
      },

      queryParams: function () {
        var params = {}

        params.person = this.setQueryParam(this.filters.person?.id)
        params.filterPerson = this.setQueryParam(
          this.filters['person.personName']
        )
        params.firma = this.setQueryParam(this.filters.firma?.id)
        params.filterFirma = this.setQueryParam(
          this.filters['person.viafirma.name']
        )
        params.kanton = this.setQueryParam(this.filters['kanton'])
        params.filterStartdatumVon = this.filters['veranstaltung.startdatumVon']
        params.filterStartdatumBis = this.filters['veranstaltung.startdatumBis']
        params.anmeldungstyp = this.setQueryParamList(
          this.filters.anmeldungstyp
        )
        params.statusAnmeldung = this.setQueryParamList(
          this.filters.statusAnmeldung
        )

        params.veranstaltung = this.setQueryParam(
          this.filters.veranstaltung?.id
        )
        /* if (this.veranstaltung) params.veranstaltung = this.setQueryParam(filters.veranstaltung?.id);
        else
          params.veranstaltung = this.setQueryParam(filters.veranstaltung?.id)
            ? this.setQueryParam(filters.veranstaltung?.id.join(","))
            : null; */

        params.geschlecht = this.setQueryParam(this.filters.geschlecht?.id)

        params.vstatus = this.setQueryParamList(
          this.filters.veranstaltungsstatus
        )
        params.vtyp = this.setQueryParamList(this.filters.veranstaltungstyp)
        params.filterVKuerzel = this.setQueryParam(
          this.filters['veranstaltung.kuerzel']
        )
        params.filterVBez = this.setQueryParam(
          this.filters['veranstaltung.bezeichnung']
        )
        params.filterASBez = this.setQueryParam(
          this.filters['anmeldestatus.bezeichnung']
        )
        params.filterATBez = this.setQueryParam(
          this.filters['anmeldetyp.bezeichnung']
        )
        params.filterBGTyp = this.setQueryParamList(
          this.filters.bildungsgangTyp
        )
        params.remarks = this.setQueryParam(this.filters.remarks)

        params.orStatement = this.setQueryParam(
          this.filters.orStatement ? 'true' : undefined
        )
        params.filterGebucht = this.setQueryParam(this.filters.gebucht)

        params.keine_kommunikationsadresse = this.setQueryParam(
          this.filters['keine_kommunikationsadresse']
        )

        params.nicht_subventioniert = this.setQueryParam(
          this.filters['nicht_subventioniert']
        )

        params.filterCount = this.setQueryParam(this.filters.count)

        return params
      },

      anmeldetypen: {
        get() {
          return this.$store.state.anmeldung.anmeldetypen
        },
      },
      anmeldestati: {
        get() {
          return this.$store.state.anmeldung.anmeldestati
        },
      },
      firmen: {
        get() {
          return this.$store.state.anmeldung.firmen
        },
      },
      geschlechter: {
        get() {
          return this.$store.state.geschaeftspartner.geschlechter
        },
      },
      veranstaltungsstati: {
        get() {
          return this.$store.state.veranstaltung.veranstaltungsstati
        },
      },
      veranstaltungstypen: {
        get() {
          return this.$store.state.veranstaltung.veranstaltungstypen
        },
      },
      bildungsgangtypen: {
        get() {
          return this.$store.state.veranstaltung.bildungsgangtypen
        },
      },
      configs: {
        get() {
          return this.$store.state.veranstaltung.bildungsgangtypen
        },
      },
    },
    watch: {},
    created() {
      if (this.anmeldetypen.length == 0)
        this.$store.dispatch(`anmeldung/${LADE_AUSWAHLWERTE_ANMELDUNG}`)

      if (this.geschlechter.length == 0)
        this.$store.dispatch(
          `geschaeftspartner/${LADE_AUSWAHLWERTE_GESCHAEFTSPARTNER}`
        )

      if (this.bildungsgangtypen.length == 0)
        this.$store.dispatch(`veranstaltung/${LADE_AUSWAHLWERTE_VERANSTALTUNG}`)

      if (
        this.gruppen.find(
          (gruppe) =>
            gruppe.id == this.$CONST('GRUPPEN').INSTRUCTOR ||
            gruppe.id == '1774DD1D796' // dozentengruppe
        )
      ) {
        this.isDozent = true
      }

      this.initFilter('anmeldung-liste', 'anmeldung/', true)
    },
    mounted() {
      if (
        !this.filters.veranstaltungstyp &&
        this.firstVisit &&
        !this.isDozent
      ) {
        // Setzen des Standardwerts nur beim ersten Besuch

        this.defaultEventType
          ? this.$set(this.filters, 'veranstaltungstyp', [
              this.defaultEventType,
            ])
          : null
        this.firstVisit = false // Markieren, dass der erste Besuch abgeschlossen ist
      }

      this.$bus.$emit('searchWithFilter')
    },
    methods: {
      refresh() {
        this.resetLoading(this)
      },
      details(anmeldungen) {
        if (anmeldungen.id) {
          this.$router.push({
            name: 'anmeldung',
            params: {
              anmeldungid: anmeldungen.id,
              anzeige: 0,
              fromRoute: 'anmeldungen-liste-skjv',
            },
          })
        }
      },

      toggleOrParameter() {
        if (this.filters.orStatement) {
          this.$set(this.filters, 'orStatement', false)
        } else {
          this.$set(this.filters, 'orStatement', true)
        }
        this.filterSearch()
      },

      oeffneLoeschenModal() {
        if (this.selectedIds.length > 0)
          this.$bus.$emit('openLoeschenModal', 'anmeldungen-loeschen-modal')
        else {
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.noregistrationselecteddeletion'),
          })
        }
      },

      anmeldungenLoeschen() {
        this.delete('anmeldung/', this.selectedIds)
      },

      ausgebenTeilnehmerliste: function () {
        if (this.selectedIds.length > 0) {
          this.selectedIds = Array.from(new Set(this.selectedIds))
          let filename = new Intl.DateTimeFormat('ch').format(new Date())

          this.pdfPath =
            server.url +
            `/pdfgenerator/pdf.act?filename=AL${filename}.pdf&report=/pdfgenerator/teilnehmer.htm&ids=${this.selectedIds}`
          this.$refs.pdfLayer.show()
        } else {
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.noregistrationselected'),
          })
        }
      },

      ausgebenTischkarten: function () {
        this.pdfPath =
          server.url +
          '/pdf/tischkarten-pdf-erzeugen-anmeldung-/pdf.act?ids=' +
          this.selectedIds.join(',')
        this.$refs.pdfLayer.show()
      },

      veranstaltungstypHintergrundfarbe(item) {
        let veranstaltungstyp = item.veranstaltung.veranstaltungstyp

        if (veranstaltungstyp) {
          //Fach:
          if (veranstaltungstyp.id == '174D91487D4') {
            return { backgroundColor: '#EAE8AC', textAlign: 'center' }
          }
          //Bildungsgang (Semester):
          else if (veranstaltungstyp.id == '174D91487DA') {
            return { backgroundColor: '#84D0E2', textAlign: 'center' }
          }
          //Kurs:
          else if (veranstaltungstyp.id == '174D91487E8') {
            return { backgroundColor: '#C3C4E2', textAlign: 'center' }
          } else {
            return { backgroundColor: '#DEEDF6', textAlign: 'center' }
          }
        } else {
          return { textAlign: 'center' }
        }
      },

      showAnmeldungUebertragen() {
        this.$bus.$emit('openAnmeldungUebertragenModal', this.selectedIds)
      },

      anmeldungGeaendert(response) {
        if (response.status == 200) {
          this.$notify({
            type: 'success',
            title: this.$t('global.actionsuccessful'),
            text: this.$t('global.registrationssuccessfullytransferred'),
          })
        } else {
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.registrationtransferfailed'),
          })
        }

        this.resetLoading(this)
      },

      setFilterPerson(person) {
        this.$set(this.filters, 'person', person)
      },

      setFilterFirma(firma) {
        this.$set(this.filters, 'firma', firma)
      },

      setFilterVeranstaltung(veranstaltung) {
        this.$set(this.filters, 'veranstaltung', veranstaltung)
      },

      showAlertModal(title, text, color, value) {
        this.alertModal.title = title
        this.alertModal.text = text
        this.alertModal.color = color
        this.alertModal.value = value
        $('#modal-alert').modal('show')
      },
      korrespondenzSwitch(value) {
        console.log(value)
        if (value == 'sBrief') {
          this.massenkorrespondenzErstellen(true, true)
        } else if (value == 'mMail') {
          this.massenmailErstellen(true, true)
        }
      },
      massenkorrespondenzErstellen(selected, exec) {
        if (!selected || this.selectedIds.length > 0) {
          let tempList = selected
            ? this.selectedObjects.map((item) =>
                item.veranstaltung.id ==
                this.selectedObjects[0].veranstaltung.id
                  ? item.person.id
                  : item.person.id
              )
            : this.$refs.selectableTable.items.map((item) =>
                item.veranstaltung.id ==
                this.$refs.selectableTable.items[0].veranstaltung.id
                  ? item.person.id
                  : item.person.id
              )

          let veranstaltungList = selected
            ? this.selectedObjects.map((item) =>
                item.veranstaltung.id ==
                this.selectedObjects[0].veranstaltung.id
                  ? true
                  : false
              )
            : this.$refs.selectableTable.items.map((item) =>
                item.veranstaltung.id ==
                this.$refs.selectableTable.items[0].veranstaltung.id
                  ? true
                  : false
              )

          if (veranstaltungList.filter((bool) => bool == false).length > 0) {
            // Es hat Personen mit einer anderen Veranstaltung in der Liste
            this.showAlertModal(
              this.$t('global.warning') + ': ',
              this.$t(
                'global.youselectedcrosseventonlygenericmasslettersmailscreated'
              ),
              null,
              this.$t('global.sletter')
            )
          } else {
            exec = true
          }
          if (exec == true) {
            let json = {
              empfaenger: [],
              person: [], // ist de facto person. Noch unsauber im Backend
              isMassKorrespondenz: true,
              anmeldung: this.selectedIds[0], // Die erste Anmeldung wird für die Verknüpfung mitgegeben, damit die Serienfelder gehen
              versand: {
                erstelltvon: this.angemeldeterMitarbeiter,
                datum: new Intl.DateTimeFormat('ch-DE').format(new Date()),
                ort: '',
                betreff: this.$t('global.newserialletter'),
              },
              inhalt: '',
              zeitpunkt: new Intl.DateTimeFormat('ch-DE').format(new Date()),
            }

            json.empfaenger = tempList
            json.person = tempList

            /* if (json.empfaenger.length == 0) {
            this.$notify({
              type: "warn",
              title: "Aktion fehlgeschlagen",
              text: "Ausgewählte Anmeldungen enthalten keine verknüpfte Person",
            });
            return;
          }*/

            Api.post('korrespondenz/', json, { params: {} }).then(
              (response) => {
                this.loading = true
                Api.post('korrespondenz/empfaenger/', json, {
                  params: {
                    korrespondenz: response.data.id,
                    isPerson: true,
                    isMassCorr: true,
                  },
                }).then((empfresponse) => {
                  this.loading = false
                  this.$router.push({
                    name: 'korrespondenz',
                    params: {
                      id: response.data.id,
                      anzeige: 0,
                    },
                  })
                })
              }
            )
          }
        } else
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.nopersonselected'),
          })
      },

      massenmailErstellen(selected, exec) {
        if (!selected || this.selectedIds.length > 0) {
          let tempList = selected
            ? this.selectedObjects.map((item) =>
                item.veranstaltung.id ==
                this.selectedObjects[0].veranstaltung.id
                  ? item.person.id
                  : item.person.id
              )
            : this.$refs.selectableTable.items.map((item) =>
                item.veranstaltung.id ==
                this.$refs.selectableTable.items[0].veranstaltung.id
                  ? item.person.id
                  : item.person.id
              )

          let veranstaltungList = selected
            ? this.selectedObjects.map((item) =>
                item.veranstaltung.id ==
                this.selectedObjects[0].veranstaltung.id
                  ? true
                  : false
              )
            : this.$refs.selectableTable.items.map((item) =>
                item.veranstaltung.id ==
                this.$refs.selectableTable.items[0].veranstaltung.id
                  ? true
                  : false
              )

          if (veranstaltungList.filter((bool) => bool == false).length > 0) {
            // Es hat Personen mit einer anderen Veranstaltung in der Liste
            this.showAlertModal(
              this.$t('global.warning') + ': ',
              this.$t(
                'global.youselectedcrosseventonlygenericmasslettersmailscreated'
              ),
              null,
              this.$t('global.mmail')
            )
          } else {
            exec = true
          }
          if (exec == true) {
            let json = {
              empfaenger: tempList,
              isMassMail: true,
              inhalt: '',
              zeitpunkt: new Intl.DateTimeFormat('ch').format(new Date()),
            }

            Api.post('mail/', json, { params: {} }).then((response) => {
              this.$router.push({
                name: 'mail',
                params: {
                  id: response.data.id,
                  anzeige: 0,
                },
              })
            })
          }
          //}
        } else
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.noregistrationselected'),
          })
      },
    },
  }
</script>

<style></style>
